<template>
  <section v-if="kActive" class="my-modal-custom">
    <div class="align-center">
      <div class="container-modal" :style="styles">
        <div class="box-modal">
          <div class="modal-title">
            <h1>{{ title }}</h1>
            <feather class="feather-icon" type="x" size="14" @click="$emit('close', false)" />
          </div>
          <div v-if="message" class="box-container">
            <h1 class="tips">
              {{ message }}
            </h1>
          </div>
          <div>
            <slot name="box" />
          </div>
          <div class="box-buttons">
            <div class="red-button"
                 :class="redActive ? 'enabled' : 'disabled'"
                 @click="(orderedCollumns = defaultData), $emit('close', false)"
            >
              {{ upButton }}
            </div>
            <div class="green-button" @click="$emit('apply')">
              <feather v-if="!modalLoading" class="icon-downloas" type="check" size="16" />
              <div v-else class="loader-icon" />
              {{ downButton }}
            </div>
          </div>
        </div>
      </div>
      <div />
    </div>
  </section>
</template>
<script>
export default {
	props: {
		width: {
			type: String,
			default: '400px',
		},
		modalLoading: {
			type: Boolean,
			default: false,
		},
		upButton: {
			type: String,
			default: 'Cancelar',
		},
		downButton: {
			type: String,
			default: 'Aplicar',
		},
		redActive: {
			type: Boolean,
			defalt: true,
		},
		defaultData: {
			type: Array,
			default: () => [],
		},
		title: {
			type: String,
			default: 'Titulo',
		},
		message: {
			type: String,
			default: null,
		},
		data: {
			type: Array,
			default: () => [],
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			drag: false,
			orderedCollumns: this.datadrag,
		};
	},
	computed: {
		kActive() {
			return this.active;
		},
		styles() {
			return {
				width: this.width,
			};
		},
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
	},
	methods: {
		download() {
			this.$emit('download', { formato: this.formato, nome: this.nome });
		},
	},
};
</script>

<style lang="scss" scoped>

.loader-icon {
  animation: is-rotating 1s infinite;
  border: 2px solid #CECECE;
  width: 15px;
  margin-right: 5px;
  border-top-color: #FF3B30;
  border-radius: 50%;
  height: 15px;
}

@keyframes is-rotating {
  to {
    transform: rotate(1turn);
  }
}

.enabled {
  display: flex !important;
}
.disabled {
  display: none !important;
}
.box-buttons {
	display: flex;
	padding-right: 20px;
	padding-left: 20px;
	height: 60px;
	justify-content: flex-end;
}
.align-center {
	width: 100%;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
}

.flip-list-move {
	transition: transform 0.1s;
}
.no-move {
	transition: transform 0s;
}
.tips {
	padding: 10px;
	font-size: 13px;
	text-align: center;
}
.my-modal-custom {
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.24);
	display: table;
	transition: all 0.1s ease;
	overflow-y: scroll;
	align-items: flex-end;
}
.container-modal {
	position: absolute;
	width: 400px;
	border-radius: 5px;
}
.feather-icon {
	background-color: #ff3b30;
	padding: 2px;
	border-radius: 50%;
	color: #fff;
	cursor: pointer;
	transition: 300ms ease;
}
.feather-icon:hover {
	background-color: #cc342c;
}
.draggable {
	display: flex;
	width: 100%;
	flex-direction: column;
	cursor: move;
}
.ghost {
	opacity: 0.5;
	background: #7f44004f;
	cursor: grabbing;
}
.item-box {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	padding-bottom: 4px;
	padding-top: 4px;
	margin-bottom: 2px;
	font-size: 12px;
	border-bottom: 1px solid #dfdfe1c5;
}
.item-box:first-child {
	border-top: 1px solid #dfdfe1c5;
}

.box-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	justify-content: center;
}
.modal-title {
	width: 100%;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
	border-bottom: 1px solid #dfdfe1c5;
}
.box-modal {
	background-color: #fff;
	width: 100%;
	display: flex;
	flex-direction: column;
	height: 90%;
	border-radius: 5px;
}
.red-button,
.green-button {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100px;
	height: 30px;
	margin-top: 10px;
	border-radius: 5px;
	text-align: center;
	color: #fff;
	cursor: pointer;
	transition: 500ms ease;
	font-size: 12px;
}
.red-button {
	background-color: #ff3b30;
	margin-right: 25px;
}
.green-button {
	background-color: #007f00;
}
.red-button:hover {
	background-color: #cc342c;
}
.green-button:hover {
	background-color: #005c00;
}

.switch {
	margin: 0px !important;
}
.icon-downloas {
	margin-right: 5px;
}
</style>
